export enum ConflictType {
  SOURCE_ADDED_SANDBOX_DELETED,
  SOURCE_ADDED_SANDBOX_MODIFIED,
  SOURCE_DELETED_SANDBOX_MODIFIED,
  SOURCE_MODIFIED_SANDBOX_MODIFIED,
  SOURCE_MODIFIED_SANDBOX_DELETED,
  UNKNOWN,
}
